import {
    Grid,
    Button
} from '@mui/material';
import tooltips from '../../store/tooltips';
import { RofButtonTooltip } from '../apps/rofburns/shared-components/RofTooltip';

/**
 * Component that renders the buttons under the Biochar Production Method button selection
 * @param {Object} props
 * @param {string | null} props.selectedCategory 'Project Info' || 'Data Monitoring' || 'Data Tables' || 'Reports'
 * @param {(selectedCategory: string) => void} props.setSelectedCategory Sets selected category
 * @param {string} props.burnType 'Flame Cap Kiln' || 'Conservation Burns'
 * @returns {JSX.Element} Buttons
 */

export default function Selections({ selectedCategory, setSelectedCategory, burnType }) {
    const generateButtons = (burnType) => {
        const buttons = [
            { text: 'Project Info', tooltip: tooltips.projectInfo },
            { text: 'Data Monitoring', tooltip: tooltips.dataMonitoring },
            {
                text: 'Data Tables',
                tooltip: tooltips.dataTables,
                disabled: burnType === 'Conservation Burns'
            },
        ]
        return burnType === 'Conservation Burns'
            ? buttons
            : [...buttons, { text: 'Reports', tooltip: tooltips.reports }]
    }

    const buttons = generateButtons(burnType)

    return (
        <Grid container sx={{ justifyContent: 'space-between', my: 2, }}>
            {buttons.map((buttonObject, index) => (
                <RofButtonTooltip
                    key={index}
                    tooltipText={buttonObject.tooltip}
                >
                    <Grid item sx={{ display: 'flex' }}>
                        <Button
                            variant={selectedCategory === buttonObject.text ? 'contained' : 'outlined'}
                            onClick={() => {
                                setSelectedCategory(buttonObject.text);
                            }}
                            disabled={buttonObject.disabled}
                        >
                            {buttonObject.text}
                        </Button>
                    </Grid>
                </RofButtonTooltip>
            ))}
        </Grid>
    )
}